import {
  CoberturaJovem,
  EstadoCivil,
  Genero,
  UtilizacaoVeiculo,
} from "#/enums";
import { DetalhesSimulacao } from "#/types";

export const MOCK_DETALHES_OFERTA: DetalhesSimulacao = {
  zeroKM: false,
  temNomeSocial: false,
  estadoCivil: EstadoCivil.CASADO,
  associado: {
    nome: "LUCIENE MADALENA MENEGHELLO DE MOURA",
    documento: "12310233846",
    dataNascimento: "1970-10-12",
    sexo: Genero.FEMININO,
  },
  endereco: {
    codigoIBGE: "4314100",
    tipoLogradouro: "Rua",
    logradouro: "Uruguai",
    bairro: "Centro",
    cidade: "Passo Fundo",
    uf: "RS",
    cep: "90150070",
  },
  veiculo: {
    chassi: "9BGKS48V0JG391004",
    placa: "FDL0H00",
    descricao: "ONIX LT AT6 1.4 ECO FLEX 4P",
    codigoFipe: "0044385",
    anoModelo: ["2018"],
    anoFabricacao: ["2018"],
  },
  inicioVigencia: "2025-05-31",
  utilizacao: UtilizacaoVeiculo.PARTICULAR,
  dataExpiracao: "2025-06-06",
  status: "ATIVA",
  renovacao: true,
  utilizadoPrestacaoServicos: false,
  coberturaResidentes: CoberturaJovem.NAO,
  dataSimulacao: "2025-05-31",
  numeroCotacao: "0119120702202500000013",
  dadosRenovacao: {
    seguradora: "BANESTES SEGUROS S/A",
    numero: "31760291604",
    codigoIdentificador: "65731760291604",
    inicioVigencia: "2024-06-17",
    fimVigencia: "2025-06-17",
    classeBonus: "0",
    quantidadeUtilizacaoSeguro: 0,
  },
};
